import { LogErrors } from './../../LogErrors'

import { DoubleAttempt } from './../Helpers/DoubleAttempt'


const GetCenterSettings = async (idCenter, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetCenterSettingsByCenterId"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/GetCenterSettingsByCenterId", {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetCenterSettings DL Settings', error)
        return { success: false, message: 'No ha sido posible obtener las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const SetCenterSettings = async (idCenter, isTheoryVisible, isQuizzVisible, isVideoVisible, isChallengeVisible, isActivityVisible, isEvaluationVisible, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter,
            isTheoryVisible: isTheoryVisible,
            isQuizzVisible: isQuizzVisible,
            isVideoVisible: isVideoVisible,
            isChallengeVisible: isChallengeVisible,
            isActivityVisible: isActivityVisible,
            isEvaluationVisible: isEvaluationVisible
        }
        
        const parameters = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/UpdateCenterSettings"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }

        // const response = await fetch(process.env.REACT_APP_API_URL + "/api/V2/Api/UpdateCenterSettings", {
        //     method: 'PUT',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Authorization': token
        //     },
        //     body: JSON.stringify(dataToSend)
        // })
        
        // if (!response.ok) {
        //     // Manejar errores HTTP
        //     const errorData = await response.json()
        //     //return { success: false, message: errorData.message || 'Error de autenticación' }
        //     return { success: false, message: errorData.message } //errorCode
        // }
        
        // const data = await response.json()
        
        // //Retornar la respuesta exitosa
        // return { success: true, data: data }
    } catch (error) {
        await LogErrors('SetCenterSettings DL Settings', error)
        return { success: false, message: 'No ha sido posible actualizar las configuraciones del centro. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

export { GetCenterSettings, SetCenterSettings };